import {AnswerOption} from './AnswerOption.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';

export class AnswerQuestion {
	constructor(parent, answerModel, questionModel) {
		this.answerModel = answerModel;
		this.model = questionModel;
		[this.el, this.$] = PollRobotTemplate(`AnswerQuestion`);
		this.$.question.innerText = questionModel.text;
		this.options = this.model.options.map( 
			o=>new AnswerOption(this.$.options, answerModel, questionModel, o) );
		parent.appendChild(this.el);
	}
}